import Fly from "./Fly.js";
import Death from "./Death.js";

export { Fly, Death };
